import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of, switchMap } from 'rxjs';
import { loadEnvironmentDataForRelease, setDeliveryGuid } from '../environment/environment.actions';
import { setPipelineReleaseViewRouteParameters } from './routing.actions';

@Injectable()
export class RoutingEffects {
  private readonly action$ = inject(Actions);
  private readonly store$ = inject(Store);

  public onSetPipelineReleaseViewRouteParametersLoadEnvironmentData = createEffect(() => {
    return this.action$.pipe(
      ofType(setPipelineReleaseViewRouteParameters),
      switchMap(() => {
        return of(loadEnvironmentDataForRelease());
      }),
    );
  });

  public onSetPipelineReleaseViewRouteParametersSetDeliveryGuid = createEffect(() => {
    return this.action$.pipe(
      ofType(setPipelineReleaseViewRouteParameters),
      switchMap((action) => {
        return of(setDeliveryGuid({ deliveryGuid: action.deliveryGuid }));
      }),
    );
  });
}
